<template>
  <v-dialog
    v-model="show"
    max-width="500"
    width="90%"
    scrollable
  >
    <v-card>
      <v-card-title>
        Move To
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          label="Search"
          dense
          hide-details
          clearable
          clear-icon="mdi-close-circle-outline"
        ></v-text-field>
        <v-btn icon @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-treeview
          v-if="reportingsToMove.length && treeItems.length && !loading"
          :items="treeItems"
          :search="search"
          :active.sync="active"
          return-object
          item-text="Name"
          :load-children="fetchTasksAndFolders"
          item-disabled="disabled"
          activatable
          color="success"
          dense
          item-children="Tasks"
          item-key="Item_ID"
        >
          <template v-slot:prepend="{ item, open }">
            <template v-if="['Project', 'Folder'].indexOf(item.Type) > -1">
              <div class="mr-2">
                <v-icon color="primary" v-if="['integrated', 'integrated-employee'].indexOf(item.Jira_Task_Key) > -1">
                  mdi-atlassian mdi-18px
                </v-icon>
                <v-icon color="primary">
                  {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                </v-icon>
              </div>
            </template>
            <v-icon class="mr-2" color="success" v-else>
              mdi-file-code
            </v-icon>
          </template>
        </v-treeview>
        <div v-else class="d-flex justify-center pa-6">
          <v-progress-circular indeterminate color="primary" size="40" />
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn small color="primary" outlined @click="show = false">cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn small color="primary" :disabled="active[0] && active[0].Type !== 'Task'" @click="moveTo">move</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { getApiErrorMessage } from '@/utils/apiError'
export default {
  name: 'MoveReportingToDialog',
  props: {
    value: {
      required: true
    },
    reportingsToMove: {
      required: true,
      default: []
    },
    assignedTo: {
      required: true,
      default: -1
    }
  },
  data () {
    return {
      treeItems: [],
      active: [],
      search: null,
      loading: false
    }
  },
  async mounted () {
    await this.getProjectsListWithTasks()
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    show: {
      get () {
        return this.value
      },
      set (value) {
        if (!value) {
          this.$emit('closed')
        }
        this.$emit('input', value)
      }
    }
  },
  methods: {
    async getProjectsListWithTasks () {
      this.loading = true
      try {
        const res = await this.axios.get('/api/selected-projects-list', {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        })

        const rawProjects = res.data

        const projectsWithTasks = await Promise.all(
          rawProjects.map(async project => {
            await this.fetchTasksAndFolders(project)
            if (project.Tasks && project.Tasks.length) {
              return project
            }
            return null
          })
        )

        this.treeItems = projectsWithTasks.filter(Boolean)
      } catch (error) {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      } finally {
        this.loading = false
      }
    },
    moveTo () {
      this.axios.post('/api/move-reports-to', {
        Task_ID: this.active[0].Task_ID,
        Project_ID: this.active[0].Project_ID,
        reports: this.reportingsToMove
      }, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('setSuccess', { successMsg: 'Successfully moved' })
        this.$emit('refreshResults', this.active[0].Project_ID)
        this.show = false
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    async fetchTasksAndFolders (item) {
      if (item.Type !== 'Project') return

      try {
        const res = await this.axios.post('/api/tasks-and-folders-list', {
          Project_ID: item.Project_ID
        }, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        })

        item.Tasks = this.preparedNewItems(res.data)
      } catch (error) {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      }
    },
    preparedNewItems (items) {
      return items
        .filter(i => (i.Type === 'Task' && i.Assigned_To === this.assignedTo) || i.Type === 'Folder')
        .map(i => {
          if (i.Type === 'Task') {
            delete i.Tasks
            return i
          }

          if (i.Tasks && i.Tasks.length > 0) {
            i.Tasks = this.preparedNewItems(i.Tasks)
            return i.Tasks.length > 0 ? i : null
          }

          return null
        })
        .filter(Boolean)
    }
  }
}
</script>
<style lang="scss" scoped>
  ::v-deep {
    .v-treeview-node__root {
      cursor: pointer;
    }
  }
</style>
